function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 12,
  cy: 11.9673,
  rx: 12,
  ry: 11.9673,
  fill: "#4D4DED"
});
var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M17.4375 18.75L14.6732 14.4107H18.6429V12.7714H5.625V14.4107H9.59464L6.83036 18.75H8.8875L12.1339 13.6554L15.3804 18.75H17.4375ZM18.6429 11.1804V9.54107H14.7536L17.4857 5.25H15.4125L12.1339 10.425L8.85536 5.25H6.78214L9.51429 9.54107H5.625V11.1964L18.6429 11.1804Z",
  fill: "white"
});
function SvgStacks(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStacks);
export default __webpack_public_path__ + "static/media/stacks.ed877a2072ea95f8c01df880afd6af0f.svg";
export { ForwardRef as ReactComponent };